import { IconButton, useMediaQuery, useTheme } from '@material-ui/core'
import { Delete, Edit, Visibility } from '@material-ui/icons'
import React from 'react'
import {
  Datagrid,
  DeleteButton,
  EditButton,
  Filter,
  FunctionField,
  Identifier,
  Link,
  ListProps,
  Pagination,
  ShowButton,
  TextField,
  TextInput,
  useDelete,
  useRefresh,
} from 'react-admin'
import { ResourceName } from '../../../core/ResourceName'
import List from '../../common/customized-ra-components/List'
import FilterProps from '../../common/FilterProps'
import { useHasAuthority } from '../../hooks/useHasAuthority'
import { DeviceManagementContainerDto } from '../../../core/dto/device/device-management/device-management-containers/DeviceManagementContainer.dto'
import { Authority } from '../../../core/auth/Authority'

const DeviceManagementContainersFilters = (props: FilterProps) => (
  <Filter {...props}>
    <TextInput source="name" alwaysOn autoFocus />
  </Filter>
)

export const DeviceManagementContainersList = ({ ...props }: ListProps) => {
  const hasAuthority = useHasAuthority()
  const theme = useTheme()
  const largeScreen = useMediaQuery(theme.breakpoints.up('md'))
  const refresh = useRefresh()
  const [deleteOne] = useDelete()

  const handleDelete = (container?: DeviceManagementContainerDto) => {
    if (container) {
      deleteOne(
        ResourceName.DEVICE_MANAGEMENT_CONTAINERS,
        container.id as Identifier,
      )
      refresh()
    }
  }

  return (
    <List
      {...props}
      perPage={20}
      pagination={<Pagination rowsPerPageOptions={[10, 20, 50, 100, 200]} />}
      exporter={false}
      filters={<DeviceManagementContainersFilters />}
      bulkActionButtons={false}
    >
      <Datagrid size="small">
        <TextField source="id" label="ID" />
        <TextField source="name" />
        <FunctionField<DeviceManagementContainerDto>
          render={(container?: DeviceManagementContainerDto) =>
            largeScreen ? (
              <ShowButton record={container} />
            ) : (
              <Link
                to={`/${ResourceName.DEVICE_MANAGEMENT_CONTAINERS}/${container?.id}/show`}
              >
                <IconButton size="small">
                  <Visibility />
                </IconButton>
              </Link>
            )
          }
        />
        {hasAuthority(Authority.EDIT_DEVICE_MANAGEMENT_CONTAINERS) && (
          <FunctionField<DeviceManagementContainerDto>
            render={(container?: DeviceManagementContainerDto) =>
              largeScreen ? (
                <EditButton record={container} />
              ) : (
                <Link
                  to={`/${ResourceName.DEVICE_MANAGEMENT_CONTAINERS}/${container?.id}`}
                >
                  <IconButton size="small">
                    <Edit />
                  </IconButton>
                </Link>
              )
            }
          />
        )}
        {hasAuthority(Authority.DELETE_DEVICE_MANAGEMENT_CONTAINERS) && (
          <FunctionField<DeviceManagementContainerDto>
            render={(container?: DeviceManagementContainerDto) =>
              largeScreen ? (
                <DeleteButton
                  record={container}
                  undoable={false}
                  resource={ResourceName.DEVICE_MANAGEMENT_CONTAINERS}
                />
              ) : (
                <IconButton
                  size="small"
                  onClick={() => handleDelete(container)}
                >
                  <Delete color="error" />
                </IconButton>
              )
            }
          />
        )}
      </Datagrid>
    </List>
  )
}
